

import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcButtonModule } from 'mwc/button';
import { MwcNoAnimationModule } from 'mwc/core/no-animation';
import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcOverlayModule } from 'mwc/core/overlay';
import { MwcIconModule } from 'mwc/icon';
import { MwcMenuModule } from 'mwc/menu';

import { MwcContextMenuServiceModule } from './context-menu.service.module';
import { MwcDropDownADirective } from './dropdown-a.directive';
import { MwcDropdownButtonDirective } from './dropdown-button.directive';
import { MwcDropdownMenuComponent } from './dropdown-menu.component';
import { MwcDropDownDirective } from './dropdown.directive';

@NgModule({
  imports: [
    BidiModule,
    CommonModule,
    OverlayModule,
    MwcButtonModule,
    MwcMenuModule,
    MwcIconModule,
    MwcNoAnimationModule,
    PlatformModule,
    MwcOverlayModule,
    MwcContextMenuServiceModule,
    MwcOutletModule
  ],
  declarations: [MwcDropDownDirective, MwcDropDownADirective, MwcDropdownMenuComponent, MwcDropdownButtonDirective],
  exports: [MwcMenuModule, MwcDropDownDirective, MwcDropDownADirective, MwcDropdownMenuComponent, MwcDropdownButtonDirective]
})
export class MwcDropDownModule {}
